export const USERS_RESET_STATE = 'USERS_RESET_STATE';
export const USERS_CURRENT_ITEM = 'USERS_CURRENT_ITEM';

export const USERS_REQUEST_LOADING = 'USERS_REQUEST_LOADING';
export const USERS_REQUEST_SUCCESS = 'USERS_REQUEST_SUCCESS';
export const USERS_REQUEST_FAILED = 'USERS_REQUEST_FAILED';

export const USERS_CURRENT_ACTION = 'USERS_CURRENT_ACTION';
export const USERS_RESET_ACTION = 'USERS_RESET_ACTION';